<template>
  <div>
    <b-modal
      id="modal-input"
      size="lg"
      centered
      title="Tambah Data Persetujuan Karyawan"
      header-bg-variant="primary"
      header-text-variant="light"
      @show="showModal()"
    >
      <b-form>
        <b-form-group label-cols-md="3">
          <template v-slot:label>
            No. Surat <span class="text-danger">*</span>
          </template>
          <b-form-input
            type="text"
            v-model="$v.data.nomorSurat.$model"
            style="width: 100%"
          ></b-form-input>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Data Karyawan <span class="text-danger">*</span>
          </template>
          <Multiselect
            v-model="$v.data.dataKaryawanId.$model"
            :options="karyawan"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="dataKaryawanId"
            label="namaKaryawan"
            placeholder="-- Pilih Karyawan --"
          ></Multiselect>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Tanggal Surat Persetujuan <span class="text-danger">*</span>
          </template>
          <date-picker
            v-model="$v.data.tanggalDibuatSurat.$model"
            style="width: 100%"
          ></date-picker>
        </b-form-group>
        <b-form-group label-cols-md="3" v-if="isSuper">
          <template v-slot:label>
            Nama Mitra <span class="text-danger">*</span>
          </template>
          <Multiselect
            v-model="$v.data.mitraId.$model"
            :state="checkIfValid('mitraId')"
            :options="mitra"
            @input="getKoordinator(data.mitraId), data.koordinatorId = null, data.cabangId = null, data.capemId = null"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group>
        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Nama Koordinator <span class="text-danger">*</span>
          </template>
          <Multiselect
            v-model="data.koordinatorId"
            :options="koordinator"
            @input="getCabang(data.koordinatorId), data.cabangId = null, data.capemId = null"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKoordinator"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Nama Cabang" label-cols-md="3">
          <Multiselect
            v-model="data.cabangId"
            :options="cabang"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCabang"
            placeholder="-- Pilih --"
            @input="getCapem(data.cabangId), data.capemId = null"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Nama Capem" label-cols-md="3">
          <Multiselect
            v-model="data.capemId"
            :options="capem"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCapem"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group>
        <!-- <b-form-group label-cols-md="3">
          <template v-slot:label>
            Detail Persetujuan <span class="text-danger">*</span>
          </template>
          <b-form-textarea
            v-model="data.detail"
            style="width: 100%"
          ></b-form-textarea>
        </b-form-group> -->
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input')">
          Batal
        </b-button>
        <b-button
          variant="primary"
          @click="simpan()"
          :disabled="!isValid || busy"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: { Multiselect, DatePicker },
  props: ["karyawan", "mitra"],
  name: "modalInput",
  data() {
    return {
      koordinator: [],
      cabang: [],
      capem: [],
      data: {
        dataKaryawanId: "",
        tanggalDibuatSurat: "",
        detail: "",
        mitraId: "",
        koordinatorId: "",
        cabangId: "",
        capemId: "",
        nomorSurat: "",
      },
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
    isSuper() {
      return this.$store.state.role_aktif.kodeRole == 'super';
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      dataKaryawanId: { required },
      tanggalDibuatSurat: { required },
      nomorSurat: { required },
      mitraId: { required },
      koordinatorId: {  },
      cabangId: {  },
      capemId: {  },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async showModal(){
      const vm = this
      vm.data.mitraId = vm.$store.state.mitra_aktif
      vm.data.koordinatorId = vm.$store.state.koordinator_aktif
      vm.data.cabangId = vm.$store.state.cabang_aktif
      vm.data.capemId = vm.$store.state.capem_aktif

      await vm.getKoordinator(vm.data.mitraId)
      await vm.getCabang(vm.data.koordinatorId)
      await vm.getCapem(vm.data.cabangId)
    },
    async getKoordinator(x) {
      const vm = this
      if(x){
        let koordinator = await vm.$axios.get("/koordinator/listKoordinatorByMitraId/" + x.id);
        //   console.log(koordinator.data.data, "ini koordinator");
        this.koordinator = koordinator.data.data;
      }
    },
    async getCabang(x) {
      const vm = this
      if(x){
        let cabang = await vm.$axios.get("/cabang/listCabangByKoordinatorId/" + x.id);
        // console.log(cabang.data.data, "ini cabang");
        vm.cabang = cabang.data.data;
      }
    },
    async getCapem(x) {
      const vm = this
      if(x){
        let capem = await vm.$axios.get("/capem/listCapemByCabangId/" + x.id);
        //   console.log(cabang.data.data, "ini cabang");
        this.capem = capem.data.data;
      }
    },
    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.data.dataKaryawanId = vm.data.dataKaryawanId.dataKaryawanId;
      if (vm.data.mitraId) {
        vm.data.mitraId = vm.data.mitraId.id;
      }
      if (vm.data.koordinatorId) {
        vm.data.koordinatorId = vm.data.koordinatorId.koordinatorId;
      }
      if (vm.data.cabangId) {
        vm.data.cabangId = vm.data.cabangId.cabangId;
      }
      if (vm.data.capemId) {
        vm.data.capemId = vm.data.capemId.capemId;
      }
      vm.$axios
        .post("suratPersetujuan/register", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.data.dataKaryawanId = "";
            vm.data.nomorSurat = "";
            vm.data.tanggalDibuatSurat = "";
            vm.$v.$reset();
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN KONTRAK KARYAWAN",
              showing: true,
            });
            this.$bvModal.hide("modal-input");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: (res.data.message).toUpperCase(),
              showing: true,
            });
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
